import { testimonials } from '@/mocks/comics';

export default function TestimonialSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
            读者口碑
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mt-4">
            听听读者怎么说
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            超过800万读者的共同选择
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm" />
                ))}
              </div>
              <blockquote className="text-sm md:text-base text-foreground-700 leading-relaxed">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <div className="flex items-center gap-3 mt-5 pt-5 border-t border-background-200">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-300 flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}